import { docReady } from './modules/tools';

docReady(() => {
});